'use client';
import React, { useState } from 'react';


export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      badge: '⚡ Fastest Delivery',
      title: 'Groceries at\nyour door in',
      highlight: '4 hours',
      subtitle: 'Fresh vegetables, dairy, snacks & more — delivered faster than ever.',
      emoji: '🛒',
    },
    {
      badge: '🎁 Combo Deals',
      title: 'Best Combos at\nUnbeatable',
      highlight: 'Prices',
      subtitle: 'Save up to 91% on grocery combos. Limited time offer!',
      emoji: '🎁',
    },
    {
      badge: '🚚 Free Delivery',
      title: 'Order Now &\nGet Delivery in',
      highlight: 'Minutes',
      subtitle: 'No minimum order value. Free delivery on all orders.',
      emoji: '🚀',
    },
  ];

  const prev = () => setCurrentSlide((s) => (s - 1 + slides?.length) % slides?.length);
  const next = () => setCurrentSlide((s) => (s + 1) % slides?.length);

  const slide = slides?.[currentSlide];

  return (
    <section className="pt-14 md:pt-16">
      {/* Hero Banner */}
      <div className="relative bg-gradient-to-r from-[#0c831f] to-[#065f12] overflow-hidden transition-all duration-500">
        <div
          className="absolute inset-0 transition-all duration-700"
          style={{ backgroundImage: 'radial-gradient(circle at 80% 50%, rgba(255,255,255,0.07) 0%, transparent 60%)' }}
        />
        <div className="absolute -right-20 -top-20 w-80 h-80 rounded-full bg-white/5 pointer-events-none" />
        <div className="absolute -right-5 bottom-0 w-52 h-52 rounded-full bg-white/5 pointer-events-none" />
        <div className="absolute left-1/2 top-1/2 w-96 h-96 rounded-full bg-black/5 -translate-x-1/2 -translate-y-1/2 pointer-events-none" />

        <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-20 flex items-center justify-between gap-8">
          <div className="flex flex-col gap-4 max-w-xl animate-fadeSlideIn">
            <span
              className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest px-3 py-1.5 rounded-full w-fit"
              style={{ background: 'rgba(255,255,255,0.15)', color: 'rgb(248,196,42)' }}
            >
              {slide?.badge}
            </span>
            <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight tracking-tight whitespace-pre-line">
              {slide?.title}
              {' '}<span style={{ color: 'rgb(248,196,42)' }}>{slide?.highlight}</span>
            </h1>
            <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-md">
              {slide?.subtitle}
            </p>
            <div className="flex items-center gap-3 mt-2">
              <button
                className="px-7 py-3.5 rounded-xl font-extrabold text-sm transition-all active:scale-95 shadow-lg"
                style={{ background: 'rgb(248,196,42)', color: 'rgb(28,28,28)' }}
              >
                Order Now
              </button>
              <button className="px-6 py-3.5 rounded-xl font-semibold text-sm border border-white/30 text-white hover:bg-white/10 transition-all">
                Browse All
              </button>
            </div>
          </div>
          <div className="hidden md:flex items-center justify-center text-[160px] select-none animate-popIn">
            {slide?.emoji}
          </div>
        </div>

        {/* Prev/Next Buttons */}
        <button
          onClick={prev}
          className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-black/20 hover:bg-black/40 flex items-center justify-center text-white transition-all backdrop-blur-sm"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="m15 18-6-6 6-6" />
          </svg>
        </button>
        <button
          onClick={next}
          className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-black/20 hover:bg-black/40 flex items-center justify-center text-white transition-all backdrop-blur-sm"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="m9 18 6-6-6-6" />
          </svg>
        </button>

        {/* Dots */}
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
          {slides?.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrentSlide(i)}
              className={`rounded-full transition-all duration-300 ${
                i === currentSlide ? 'w-6 h-2 bg-white' : 'w-2 h-2 bg-white/40'
              }`}
            />
          ))}
        </div>
      </div>
      {/* Yellow Banner */}
      <div className="bg-[#f8c42a]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 flex items-center justify-center gap-3">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="fill-[#1c1c1c] text-[#1c1c1c]" aria-hidden="true">
            <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
          </svg>
          <p className="text-xs md:text-sm font-bold text-[#1c1c1c] tracking-wide">
            FREE DELIVERY &nbsp;·&nbsp; 4 HOURS EXPRESS &nbsp;·&nbsp; BEST PRICES GUARANTEED &nbsp;·&nbsp; 7-DAY EASY RETURNS
          </p>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="fill-[#1c1c1c] text-[#1c1c1c]" aria-hidden="true">
            <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
          </svg>
        </div>
      </div>
    </section>
  );
}
